export default __webpack_public_path__ + "static/media/ic-mail-black.d33e5623.svg";